<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-clipboard-list"
      texto-titulo="Editar repartidor"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarRepartidor()">
          <float-label label="Nombre:" clase>
            <input
              v-model="repartidor.nombre"
              id="nombre"
              placeholder="Ingresar un nombre..."
              type="text"
              class="form-control"
              :class="
                enviado && !$v.repartidor.nombre.required ? 'is-invalid' : ''
              "
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.repartidor.nombre.required"
              >
                Debe ingresar un nombre
              </div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import { required } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Repartidor from "@/models/repartidor";
export default {
  name: "EditarRepartidor",
  components: {
    TituloComponent,
    BlockUI,
    FloatLabel,
  },
  data() {
    return {
      repartidor: new Repartidor(null, ""),
      loading: false,
      enviado: false,
    };
  },
  validations: {
    repartidor: {
      nombre: { required },
    },
  },
  mounted() {
    this.repartidor.id = this.$route.params.id;
    this.getRepartidor();
  },
  methods: {
    getRepartidor() {
      this.loading = true;
      axios
        .get("repartidores/" + this.repartidor.id)
        .then((res) => {
          if (res.data.success) {
            this.repartidor = res.data.repartidor;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado repartidor.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarRepartidor() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .put("/repartidores/" + this.repartidor.id, this.repartidor)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.repartidor.nombre} se editó con éxito.`,
            });
            this.$router.push({ name: "ListarRepartidores" });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
